import { render, staticRenderFns } from "./radishScore.vue?vue&type=template&id=f1218ed8&scoped=true&"
import script from "./radishScore.vue?vue&type=script&lang=js&"
export * from "./radishScore.vue?vue&type=script&lang=js&"
import style0 from "./radishScore.vue?vue&type=style&index=0&id=f1218ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1218ed8",
  null
  
)

export default component.exports